/* eslint-disable */
let icons = [
  {
    id: 'scene',
    label: '场景模型',
    icon: 'scene'
  },
  {
    id: 'mountain',
    label: '地形',
    icon: 'mountain'
  },
  {
    id: 'material',
    label: '材质库',
    icon: 'material'
  },
  {
    id: 'model',
    label: '模型库',
    icon: 'model',
  },
  {
    id: 'road',
    label: '道路',
    icon: 'road'
  },
]

export {icons}
